import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { KeyCloakCustomService } from '../../keycloak/services/key-cloak-custom-service';
import { JoetStoreService } from '../../shared/services/joet-store.service';

export const ReviewRedirectGuard: CanActivateChildFn  = async (route, state) => {
    const keyCloakService = inject(KeyCloakCustomService);
    const joetStoreService = inject(JoetStoreService);
    const router = inject(Router);

    // check if user is logged in
    if (keyCloakService.isLoggedIn()) {
   // const role = localStorage.getItem('role');
    if(state.url.includes('submit-review') ||  state.url.includes('update-password') ||    state.url.includes('give-tip') ) {
    return true;
    }
   
    if(joetStoreService.isDriver() || joetStoreService.isCustomer()) {
      if(joetStoreService.userBaseInfoForClaims()?.isTipConsentPending) {
      if (joetStoreService.isCustomer() == true) {
    return  router.navigate(['user/give-tip', joetStoreService.userBaseInfoForClaims()?.requestIdForPendingReview ?? ""]);
    }
  }
     if(joetStoreService.userBaseInfoForClaims()?.isAnyReviewPending) {
      if (joetStoreService.isCustomer() == true) {
    return  router.navigate(['user/booking/submit-review', joetStoreService.userBaseInfoForClaims()?.requestIdForPendingReview ?? ""]);
    }
    if (joetStoreService.isDriver() == true) {
      return router.navigate(['driver/booking/submit-review', joetStoreService.userBaseInfoForClaims()?.requestIdForPendingReview ?? ""]);
    }
     }

      
    }  
    
    if(joetStoreService.userBaseInfoForClaims()?.isPasswordUpdatePending) {
             return  router.navigate(['/'+joetStoreService.getBaseDashboardRoute()+'/update-password']);
     
     }
    return true;
    } else {
        // redirect to login, preserve return URL
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
};
